import { render } from "./iconsvg.vue?vue&type=template&id=8f61c980"
import script from "./iconsvg.vue?vue&type=script&lang=js"
export * from "./iconsvg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__